import { ReactComponent as Key } from "assets/icons/key.svg";
import * as s from "../LyveStyled";
import { IoIosCopy } from "react-icons/io";
import { handleCopyClipBoard } from "utils/functions";

interface KeyColumnProp {
  subscriptionKey: string;
}

export function SubscriptionKeyColumn({
  subscriptionKey,
}: KeyColumnProp): JSX.Element {
  return (
    <s.KeyColumn>
      <Key />
      <span>{subscriptionKey}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleCopyClipBoard(subscriptionKey, "Key");
        }}
        data-testid="subscription-lyve-button-copy"
      >
        <IoIosCopy />
      </button>
    </s.KeyColumn>
  );
}
